// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__tHBTO","image":"styles_image__45DIK","title":"styles_title__GwQm_","description":"styles_description__ifPba"};